import { customerPathFromSignature } from "@timeedit/registration-shared";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface NavigateWithSignatureProps {
  customerSignature: string | null | undefined;
  root: string;
}

/**
 * Catch-all route element. Sends any prefixed, unknown path to the root page.
 * Prefixes the current URL with the customer path when the prefix is missing
 * and forwards to the real routes.
 */
export function NavigateWithSignature({
  customerSignature,
  root,
}: NavigateWithSignatureProps): null {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!customerSignature) {
      return;
    }
    const prefix = `/${customerPathFromSignature(customerSignature)}`;
    const isPrefixedPath =
      location.pathname === prefix ||
      location.pathname.startsWith(`${prefix}/`);

    if (isPrefixedPath) {
      navigate(`${prefix}/${root}`, { replace: true });
    } else {
      navigate(
        { pathname: `${prefix}${location.pathname}`, search: location.search },
        { replace: true }
      );
    }
  }, [customerSignature, root, location.pathname, location.search, navigate]);

  return null;
}
